import React from "react";
import "./ClientList.css";

const ClientList = () => {
  return (
    <div>
      <h1>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est, eligendi?
      </h1>
    </div>
  );
};

export default ClientList;
